import React from 'react';
import { twMerge } from 'tailwind-merge';

type TextSize = 'xs' | 'sm' | 'md' | 'base' | 'lg' | 'xl' | '2xl' | '3xl' | '4xl';
type TextColor = string; // adjust based on your tailwind.config
type TextAs = 'span' | 'p';

interface ITextProps extends React.HTMLAttributes<HTMLSpanElement> {
    size?: TextSize;
    color?: TextColor;
    /** Render as paragraph (`<p>`) for block text or span (default) for inline */
    as?: TextAs;
    children: React.ReactNode;
    className?: string;
}

const sizeMap: Record<TextSize, string> = {
    'xs': 'text-xs',
    'sm': 'text-sm',
    'md': 'text-md',
    'base': 'text-base',
    'lg': 'text-lg',
    'xl': 'text-xl',
    '2xl': 'text-2xl',
    '3xl': 'text-3xl',
    '4xl': 'text-4xl',
};

const colorMap: Record<TextColor, string> = {
    'primary': 'text-primary',
    'secondary': 'text-secondary',
};

function Text({
    size = 'base',
    color = 'text-inherit',
    as: Component = 'span',
    children,
    className,
    ...props
}: ITextProps) {
    const sizeClass = sizeMap[size];
    const colorClass = colorMap[color] ?? color;

    return (
        <Component
            className={twMerge(sizeClass, colorClass, className)}
            {...props}
        >
            {children}
        </Component>
    );
}

export type { ITextProps, TextAs };
export default Text;